module.exports = __webpack_public_path__ + "img/89.b4238385.jpg";